import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=46506782&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=46506782&prod&lang=css"
import style1 from "./ProjectDetail.vue?vue&type=style&index=1&id=46506782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46506782",
  null
  
)

export default component.exports